import { PortfolioSection } from '@/components/dashboard/PortfolioSection'

export function PortfolioPage() {
  return (
    <div style={{ maxWidth: 1280, margin: '0 auto', padding: '24px' }}>
      <PortfolioSection />
    </div>
  )
}
